import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { institucionService } from 'services/institucionService';
import { bootstrapService } from 'services/bootstrapService';

const rootElement = document.getElementById('root') as HTMLElement;

Promise.all([
  institucionService.get().catch(e => {
    console.warn('[institucion] No se pudo cargar la configuración institucional:', e);
  }),
  bootstrapService.cargar().catch(e => {
    console.warn('[bootstrap] No se pudieron cargar los catálogos iniciales:', e);
  }),
]).finally(() => {
  ReactDOM.createRoot(rootElement).render(<App />);
});
